import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust path if necessary
import './ApprovedAddons.css'; // Your existing CSS file for styling

const ApprovedAddons = () => {
  const [approvedAddons, setApprovedAddons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchApprovedAddons = async () => {
      try {
        setLoading(true);
        const approvedRef = collection(db, 'Addon_Approved');
        // Query remains correct: order the results by the approval date, newest first
        const q = query(approvedRef, orderBy('approvedAt', 'desc'));

        const querySnapshot = await getDocs(q);
        setApprovedAddons(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        setError(null);
      } catch (err) {
        console.error('Error fetching approved addons:', err);
        setError('Failed to fetch approved addon data. Check console for errors.');
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedAddons();
  }, []); // The empty dependency array means this runs once on component mount

  if (loading) {
    return <div>Loading approved addons...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="approved-addons-container">
      <h1>Approved Addon History</h1>
      <div className="table-wrapper">
        <table className="approved-table">
          {/* ================================================================ */}
          {/* === UPDATED TABLE HEADERS FOR MULTI-ITEM ORDERS              === */}
          {/* ================================================================ */}
          <thead>
            <tr>
              <th>Approved At</th>
              <th>Customer Name</th>
              <th>Items in Order</th>
              <th>Total Order Cost</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {approvedAddons.length > 0 ? (
              approvedAddons.map((order) => (
                <tr key={order.id}>
                  <td>
                    {order.approvedAt
                      ? new Date(order.approvedAt.seconds * 1000).toLocaleString()
                      : 'N/A'}
                  </td>
                  <td>{order.customerName}</td>
                  {/* ================================================================ */}
                  {/* === CORRECTED: Displaying the list of items from the array   === */}
                  {/* ================================================================ */}
                  <td>
                    <ul className="item-list">
                      {order.items && order.items.map((item, index) => (
                        <li key={index}>
                          {item.foodItemName} (Qty: {item.quantity})
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td>{order.totalOrderCost}</td>
                  <td>
                    <span className={`status-badge status-${order.status}`}>
                      {order.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              // Corrected colSpan to match the new number of columns
              <tr>
                <td colSpan="5">No approved addon orders found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ApprovedAddons;